module.exports = __webpack_public_path__ + "static/media/enterprise-software-development.a1acd95a.svg";